<template>
  <div class="bg-g padding-top-1x">
    <div class="border-5x bg-w margin-left-3x margin-right-3x padding-top-1x">
      <div class="tupian flex-row justify-between">
        <img
          :src="uploadpath + 'shopimg/' + item.img"
          v-for="(item, i) in imglist"
          v-bind:key="i"
          class="margin-right-1x width"
        />
      </div>
      <div class="margin-left f-32 f-b2">{{ shop.name }}</div>
      <div class="flex-row flex-center margin-left margin-top-3x">
        <img
          @click="phone"
          class="icon-13x"
          :src="uploadpath + 'resource/' + Res.phone"
          alt=""
        />
        <div class="f-g4" @click="phone">{{ shop.phone }}</div>
      </div>
      <!-- <div class="height-10"></div> -->
      <div
        class="flex-row margin-left margin-top padding-top-1x"
        @click="address"
      >
        <img
          class="icon-13x"
          :src="uploadpath + 'resource/' + Res.address"
          alt=""
        />
        <div class="f-24 f-g4">
          {{ shop.address }}
        </div>
      </div>
      <div>
        <div class="flex-row flex-center margin-top-3x btn">
          <div class="flex-center text-center" style="width: 50%">
            <div class="flex-row flex-center" style="justify-content:center">
              <div class="h2 f-b2 ">优度值</div>
              <div>
                <img
                class="icon-13x margin-left-1x"
                :src="uploadpath + 'resource/' + Res.zhushi"
                alt=""
                @click="isgoodexplain"
              />
              <el-dialog :visible.sync="goodexplain" width="70%" :show-close="false">
                <span>{{ Inst.goodexplain }}</span>
              </el-dialog>
              </div>
            </div>
            <!-- <div> -->
            <div class="margin-top-3x f-warn1" :class="shop.ranking == 0 ? 'f-40' : 'f-48 bold-5'">
              {{ shop.ranking == 0 ? "暂无数据" : shop.good }}
            </div>
            <!-- <div class="f-36 margin-top-3x f-w">{{ shop.dianpunum }}</div> -->
            <!-- </div> -->
          </div>
          <div class="shuxian"></div>
          <div class="flex-center text-center" style="width: 50%">
            <div class="flex-row flex-center"  style="justify-content:center">
              <div class="h2 f-b2">热度值</div>
              <img
                class="icon-13x margin-left-1x"
                :src="uploadpath + 'resource/' + Res.zhushi"
                alt=""
                @click="ishotexplain"
              />
              <el-dialog :visible.sync="hotexplain" width="70%" :show-close="false">
                <span>{{ Inst.hotexplain }}</span>
              </el-dialog>
            </div>
            <div class="margin-top-3x f-warn1 " :class="shop.ranking == 0 ? 'f-40' : 'f-48 bold-5'">
              {{ shop.ranking == 0 ? "暂无数据" : shop.hot }}
            </div>
          </div>
        </div>
        <div class="hengxian margin-left-5x"></div>
        <div class="flex-row flex-center btn">
          <div class="flex-center text-center" style="width: 50%">
            <div class="h2 f-b2">优度排名</div>
            <!-- <div> -->
            <div
              class="f-48 margin-top-3x f-warn1 bold-5"
              v-if="shop.ranking != 0"
            >
              {{ shop.ranking }}/{{ shop.dianpunum }}
            </div>
            <div class="f-40 margin-top-3x f-warn1" v-else>暂无数据</div>
            <!-- <div class="f-36 margin-top-3x f-w">{{ shop.dianpunum }}</div> -->
            <!-- </div> -->
          </div>
          <div class="shuxian"></div>
          <div class="flex-center text-center" style="width: 50%">
            <div class="h2 f-b2">热度排名</div>
            <div
              class="f-48 margin-top-3x f-warn1 bold-5"
              v-if="shop.ranking != 0"
            >
              {{ shop.hot_ranking }}/{{ shop.dianpunum }}
            </div>
            <div class="f-40 margin-top-3x f-warn1" v-else>暂无数据</div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex-row flex-center">
      <div class="margin-left-3x margin-top-4x">店铺比较信息</div>
      <img
                class="icon-13x margin-left-1x margin-top-4x"
                :src="uploadpath + 'resource/' + Res.zhushi"
                alt=""
                @click="ispkexplain"
              />
              <el-dialog :visible.sync="pkexplain" width="70%" :show-close="false">
                <span>{{ Inst.shop_pk_explain }}</span>
              </el-dialog>
    </div>
    <div class="margin-left-3x echart margin-top-3x">
      <div class="flex-center justify-between">
        <div class="style-button bg-g11">
          <div class="f-w" @click="last">上一页</div>
        </div>
        <div class="style-button1 bg-w flex-row flex-center">
          <div class="f-s2" @click="shouye">首页</div>
          <img
                class="icon-13x margin-left-1x"
                :src="uploadpath + 'resource/' + Res.shouye"
                alt=""
              />
        </div>
      </div>
      <div id="atlasChart"></div>
    </div>
  </div>
</template>

<script>
import Config from "../Config";
import { PageHelper } from "../PageHelper";
import { HttpHelper } from "../HttpHelper";
import { Utils } from "../Utils";
import Swiper from "swiper";
import { Toast } from "vant";

import * as echarts from "echarts";

export default {
  inject: ["reload"], //原来导入App.vue中的刷新方法
  data() {
    return {
      Res: {},
      Inst: {},
      Member: null,
      bannerlist: [],
      productlist: [],
      problemlist: [],
      attrlist: [],
      list: [],
      show: false,
      right: "A",
      shop: [],
      mobile: "",
      detail_id: "",
      imglist: [],
      list: ["123"],
      type: "",
      toplist: [],
      isone: "", //判断是否已经是最后一个详情页面，1为是，0为不是
      goodexplain: false,
      hotexplain: false,
      pkexplain: false
    };
  },
  created() {
    PageHelper.Init(this);
    this.detail(this.$route.params.id, this.$route.params.isone);
  },
  mounted() {
    this.top();
  },
  methods: {
    isgoodexplain() {
      this.goodexplain = true;
    },
    ishotexplain() {
      this.hotexplain = true;
    },
    ispkexplain() {
      this.pkexplain = true;
    },
    phone() {
      // console.log(this.mobile);
      window.location.href = "tel://" + this.mobile;
    },
    last() {
      var that = this;
      if (that.isone != 1) {
        this.$router.back();
        setTimeout(function () {
          // console.log(that.$route.params.id)
          that.detail(that.$route.params.id, that.$route.params.isone);
          that.top();
        }, 100);
      } else {
        Toast(this.Inst.lastpage);
      }
    },
    shouye() {
      // this.$router.go(-1)
      this.routeto("/");
    },
    address() {},
    detail(ids, isone) {
      this.isone = isone;
      HttpHelper.Post("shop/detail", { id: ids }).then((shop) => {
        this.detail_id = ids;
        this.shop = shop;
        this.mobile = shop.phone;
        this.type = shop.type;
      });
      console.log(this.type);
      HttpHelper.Post("shop/imglist", { id: ids }).then((imglist) => {
        this.imglist = imglist;
      });
    },
    montheahcrt(list) {
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById("atlasChart"));
      let option = {
        title: {},
        tooltip: {},
        animationDurationUpdate: 1500,
        animationEasingUpdate: "quinticInOut",
        series: [
          {
            type: "graph",
            layout: "none",
            symbolSize: 52,
            //设置缩放
            roam: false,
            label: {
              show: true,
            },
            edgeSymbol: ["circle", "arrow"],
            edgeSymbolSize: [4, 10],
            edgeLabel: {
              fontSize: 10,
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  if (params.name == "本店") {
                    return "#B1AE58";
                  } else if (
                    list[10].ranking != 0 &&
                    list[10].ranking == list[params.dataIndex - 1].id
                  ) {
                    // console.log(list);
                    return "#999999";
                  } else {
                    return "#3358fb";
                  }
                },
              },
            },
            // color:'#B1AE58',
            data: [
              {
                name: "本店",
                x: 0,
                y: 0,
              },
              {
                name: "TOP 1",
                x: 100,
                y: 0,
              },
              {
                name: "TOP 2",
                x: 80.9,
                y: 58.78,
              },
              {
                name: "TOP 3",
                x: 30.9,
                y: 95.11,
              },
              {
                name: "TOP 4",
                x: -30.9,
                y: 95.11,
              },
              {
                name: "TOP 5",
                x: -80.9,
                y: 58.78,
              },
              {
                name: "TOP 6",
                x: -100,
                y: 0,
              },
              {
                name: "TOP 7",
                x: -80.9,
                y: -58.78,
              },
              {
                name: "TOP 8",
                x: -30.9,
                y: -95.11,
              },
              {
                name: "TOP 9",
                x: 30.9,
                y: -95.11,
              },
              {
                name: "TOP 10",
                x: 80.9,
                y: -58.78,
              },
            ],
            // links: [],

            // data: [
            //   {
            //     name: "本店",
            //     x: 0,
            //     y: 0,
            //   },
            //   {
            //     name: "TOP 1",
            //     x: 100,
            //     y: 0,
            //   },
            //   {
            //     name: "TOP 2",
            //     x: 76.60,
            //     y: 64.28,
            //   },
            //   {
            //     name: "TOP 3",
            //     x: 17.36,
            //     y: 98.48,
            //   },
            //   {
            //     name: "TOP 4",
            //     x: -50.00,
            //     y: 86.60,
            //   },
            //   {
            //     name: "TOP 5",
            //     x: -93.97,
            //     y: 34.20,
            //   },
            //   {
            //     name: "TOP 6",
            //     x: -93.97,
            //     y: -34.20,
            //   },
            //   {
            //     name: "TOP 7",
            //     x: -50.00,
            //     y: -86.60,
            //   },
            //   {
            //     name: "TOP 8",
            //     x: 17.36,
            //     y: -98.48,
            //   },
            //   {
            //     name: "TOP 9",
            //     x: 76.60,
            //     y: -64.28,
            //   },

            // ],
            links: [
              {
                source: "TOP 1",
                target: "本店",
                lineStyle: {
                  curveness: 0.15,
                  color: "#3358fb",
                  width: 4,
                },
                label: {
                  show: true,
                  formatter: list[0].ordershop,
                },
              },
              {
                source: "TOP 2",
                target: "本店",
                lineStyle: {
                  curveness: 0.15,
                  color: "#3358fb",
                  width: 4,
                },
                label: {
                  show: true,
                  formatter: list[1].ordershop,
                },
              },
              {
                source: "TOP 3",
                target: "本店",
                lineStyle: {
                  curveness: 0.15,
                  color: "#3358fb",
                  width: 4,
                },
                label: {
                  show: true,
                  formatter: list[2].ordershop,
                },
              },
              {
                source: "TOP 4",
                target: "本店",
                lineStyle: {
                  curveness: 0.15,
                  color: "#3358fb",
                  width: 4,
                },
                label: {
                  show: true,
                  formatter: list[3].ordershop,
                },
              },
              {
                source: "TOP 5",
                target: "本店",
                lineStyle: {
                  curveness: 0.15,
                  color: "#3358fb",
                  width: 4,
                },
                label: {
                  show: true,
                  formatter: list[4].ordershop,
                },
              },
              {
                source: "TOP 6",
                target: "本店",
                lineStyle: {
                  curveness: 0.15,
                  color: "#3358fb",
                  width: 4,
                },
                label: {
                  show: true,
                  formatter: list[5].ordershop,
                },
              },
              {
                source: "TOP 7",
                target: "本店",
                lineStyle: {
                  curveness: 0.15,
                  color: "#3358fb",
                  width: 4,
                },
                label: {
                  show: true,
                  formatter: list[6].ordershop,
                },
              },
              {
                source: "TOP 8",
                target: "本店",
                lineStyle: {
                  curveness: 0.15,
                  color: "#3358fb",
                  width: 4,
                },
                label: {
                  show: true,
                  formatter: list[7].ordershop,
                },
              },
              {
                source: "TOP 9",
                target: "本店",
                lineStyle: {
                  curveness: 0.15,
                  color: "#3358fb",
                  width: 4,
                },
                label: {
                  show: true,
                  formatter: list[8].ordershop,
                },
              },
              {
                source: "TOP 10",
                target: "本店",
                lineStyle: {
                  curveness: 0.15,
                  color: "#3358fb",
                  width: 4,
                },
                label: {
                  show: true,
                  formatter: list[9].ordershop,
                },
              },
              {
                source: "本店",
                target: "TOP 1",
                lineStyle: {
                  curveness: 0.15,
                  color: "#B1AE58",
                },
                label: {
                  show: true,
                  formatter: list[0].bendian,
                },
              },
              {
                source: "本店",
                target: "TOP 2",
                lineStyle: {
                  curveness: 0.15,
                  color: "#B1AE58",
                },
                label: {
                  show: true,
                  formatter: list[1].bendian,
                },
              },
              {
                source: "本店",
                target: "TOP 3",
                lineStyle: {
                  curveness: 0.15,
                  color: "#B1AE58",
                },
                label: {
                  show: true,
                  formatter: list[2].bendian,
                },
              },
              {
                source: "本店",
                target: "TOP 4",
                lineStyle: {
                  curveness: 0.15,
                  color: "#B1AE58",
                },
                label: {
                  show: true,
                  formatter: list[3].bendian,
                },
              },
              {
                source: "本店",
                target: "TOP 5",
                lineStyle: {
                  curveness: 0.15,
                  color: "#B1AE58",
                },
                label: {
                  show: true,
                  formatter: list[4].bendian,
                },
              },
              {
                source: "本店",
                target: "TOP 6",
                lineStyle: {
                  curveness: 0.15,
                  color: "#B1AE58",
                },
                label: {
                  show: true,
                  formatter: list[5].bendian,
                },
              },
              {
                source: "本店",
                target: "TOP 7",
                lineStyle: {
                  curveness: 0.15,
                  color: "#B1AE58",
                },
                label: {
                  show: true,
                  formatter: list[6].bendian,
                },
              },
              {
                source: "本店",
                target: "TOP 8",
                lineStyle: {
                  curveness: 0.15,
                  color: "#B1AE58",
                },
                label: {
                  show: true,
                  formatter: list[7].bendian,
                },
              },
              {
                source: "本店",
                target: "TOP 9",
                lineStyle: {
                  curveness: 0.15,
                  color: "#B1AE58",
                },
                label: {
                  show: true,
                  formatter: list[8].bendian,
                },
              },
              {
                source: "本店",
                target: "TOP 10",
                lineStyle: {
                  curveness: 0.15,
                  color: "#B1AE58",
                },
                label: {
                  show: true,
                  formatter: list[9].bendian,
                },
              },
            ],
            lineStyle: {
              // color:'#3358fb',
              opacity: 0.9,
              // width: 2,
              curveness: 0,
            },
          },
        ],
      };
      myChart.setOption(option);
      myChart.off("click");
      myChart.on("click", (param) => {
        if (param.dataType == "node") {
          // this.detail(list[param.dataIndex - 1].id);
          this.routeto("/detail/" + list[param.dataIndex - 1].id + "/" + 0);
          this.detail(list[param.dataIndex - 1].id, 0);
          // this.reload();
          console.log("123");
          this.top();
        }
      });
    },
    top() {
      HttpHelper.Post("shop/detail", { id: this.$route.params.id }).then(
        (shop) => {
          HttpHelper.Post("shop/top", { type: shop.type, id: shop.id }).then(
            (top) => {
              // console.log(top);
              this.toplist = top;
              this.montheahcrt(top);
            }
          );
        }
      );
    },
  },
};
</script>
<style >
#atlasChart {
  width: 660px;
  height: 660px;
  margin-left: 10px;
  /* background: rgba(242, 242, 242, 1); */
}
.style-button {
  height: 50px;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 0px 25px 25px 0px;
}
.style-button1 {
  height: 48px;
  padding-left: 20px;
  padding-right: 20px;
  border-left: 1px #9c9e21 solid;
  border-top: 1px #9c9e21 solid;
  border-bottom: 1px #9c9e21 solid;
  border-radius: 25px 0px 0px 25px;
}
.width {
  flex-shrink: 0;
}
.tupian {
  margin: 20px;
  overflow-x: scroll;
  height: 220px;
  border-radius: 20px;
  flex-direction: row;
}

.btn {
  padding: 30px 0;
  border-radius: 0px 0px 20px 20px;
}
.echart {
  width: 690px;
  height: 750px;
  background: #fefefe;
  border-radius: 20px;
  padding-top: 20px;
}
.hengxian {
  width: 590px;
  height: 1px;
  background: #999999;
}
.shuxian {
  width: 1px;
  height: 160px;
  background: #999999;
}
.el-dialog__wrapper {
  position: fixed;
  top: 25%;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Detail.vue